import { ReportPDFTemplate } from "../configs/reportPDFTemplate";
import { pdf } from "@react-pdf/renderer";

export const getPDFLink = async () => {
  const blob = await pdf(<ReportPDFTemplate />).toBlob();
  const PDFLink = URL.createObjectURL(blob); // Update to allow string type
  return PDFLink;
};
